module.exports = __webpack_public_path__ + "img/bg4.fb307734.jpg";